export default __webpack_public_path__ + "static/media/abstracto4.b167c969.jpg";